module.exports = __webpack_public_path__ + "static/media/ProfileWhite.c5a6b6f3.svg";